import React, { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useFeatureFlags } from "@/lib/featureFlags";
import DepotLists from "./DepotLists";

export default function MemberDepot() {
  const { document_upload: uploadsEnabled } = useFeatureFlags();
  const [forms, setForms] = useState([]);
  const [handouts, setHandouts] = useState([]);
  const [submittingId, setSubmittingId] = useState(null);

  const load = useCallback(async () => {
    try {
      const [fm, ho] = await Promise.all([
        api.get("/document-depot/my-forms"),
        api.get("/document-depot/my-handouts"),
      ]);
      setForms(fm.data.items || []);
      setHandouts(ho.data.items || []);
    } catch { /* noop */ }
  }, []);

  useEffect(() => { load(); }, [load]);

  const onSubmit = async (formId, { file }, done) => {
    if (file && file.size > 25 * 1024 * 1024) return toast.error("File is too large. Maximum size is 25 MB.");
    setSubmittingId(formId);
    try {
      const fd = new FormData();
      if (file) fd.append("file", file);
      await api.post(`/document-depot/forms/${formId}/submit`, fd);
      toast.success("Submitted — your coach will review it.");
      done?.();
      load();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setSubmittingId(null); }
  };

  return (
    <div>
      <div className="mb-4">
        <h1 className="font-heading text-2xl font-extrabold text-slate-900">Document Depot</h1>
        <p className="text-sm text-slate-500">Submit your assigned forms and open handouts shared with you.</p>
      </div>
      <DepotLists forms={forms} handouts={handouts} onSubmit={onSubmit} submittingId={submittingId} uploadsEnabled={uploadsEnabled} />
    </div>
  );
}
